module.exports = __webpack_public_path__ + "img/787.3ac21065.png";